import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from "@material-ui/core";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useTranslation } from 'react-i18next';
/** Import reducers */
import {
  changeCheckBox,
  changeCheckBoxFreeText,
  selectCxAnswerSet,
} from "./PreviewReducer";

/** Import components */
import { QuestionText } from "../question/QuestionText";

import { PreviewQuestionOption } from "./PreviewType";

export const CheckBox = (props: {
  pageIndex: number;
  questionIndex: number;
  cxQuestion: any;
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  // FIXME 本来はpageIndexを取得するhookを作るべき
  const { pageIndex, questionIndex, cxQuestion } = props;

  const cxAnswerSets = useAppSelector((state) => {
    const cxQuestionPage = state.preview.answer[pageIndex];
    const cxAnswer = cxQuestionPage.cxAnswers[questionIndex];

    return cxAnswer.cxAnswerSets;
  });

  const handleFreeTextChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    cxQuestionOption: PreviewQuestionOption
  ) =>
    dispatch(
      changeCheckBoxFreeText({
        pageIndex,
        questionIndex,
        cxQuestionOption,
        freeText: event.target.value as string,
      })
    );

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    cxQuestionOption: PreviewQuestionOption
  ) =>
    dispatch(
      changeCheckBox({
        pageIndex,
        questionIndex,
        cxQuestionOption,
        checked: event.target.checked,
        value: event.target.value as string,
      })
    );

  const formControlLabels = cxQuestion.questionOptions.map(
    (cxQuestionOption: PreviewQuestionOption) => {
      let freeTextComponent = <></>;

      // チェックされている回答値を取得
      const cxAnswerSet = selectCxAnswerSet(cxAnswerSets, cxQuestionOption);

      let checked = false;

      // 選択されているオプションがテキスト入力付きの場合
      if (cxAnswerSet.answerStr) {
        checked = true;
        const freeText = cxAnswerSet.answerSubStr;

        if (cxQuestionOption.withFreeText) {
          const placeholder = cxQuestionOption.freeTextPlaceholder;

          let requiredLabelColor: string;
          let requiredLabelText: string;

          if (cxQuestionOption.freeTextRequired) {
            requiredLabelColor = `#F49494`;
            requiredLabelText = t('preview.checkbox.required');
          } else {
            requiredLabelColor = `#C4C4C4`;
            requiredLabelText = t('preview.checkbox.optional');
          }

          freeTextComponent = (
            <React.Fragment>
              {/* 必須、任意ラベル */}
              <Box mt={0} mb={1}>
                <Box
                  textAlign="textBottom"
                  display="inline-block"
                  ml={1}
                  px={2}
                  borderRadius="8px"
                  fontSize="12px"
                  style={{ backgroundColor: requiredLabelColor }}
                >
                  {requiredLabelText}
                </Box>
              </Box>
              <TextField
                fullWidth
                variant="outlined"
                value={freeText}
                onChange={(event) =>
                  handleFreeTextChange(event, cxQuestionOption)
                }
                placeholder={placeholder}
                inputProps={{ maxLength: 100 }}
              />
            </React.Fragment>
          );
        }
      }

      return (
        <React.Fragment key={cxQuestionOption.id}>
          <FormControlLabel
            value={cxQuestionOption.optionText}
            control={
              <Checkbox
                color="primary"
                checked={checked}
                onChange={(event) => handleChange(event, cxQuestionOption)}
                name={cxQuestionOption.optionText}
              />
            }
            label={cxQuestionOption.optionText}
            style={{ wordBreak: "break-word" }}
          />
          {freeTextComponent}
        </React.Fragment>
      );
    }
  );

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={6}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <FormGroup>{formControlLabels}</FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
